import configuration from "../../configuration";
import ODataFulogicsStore from "fulogics-ui-core/dist/api/odata/ODataFulogicsStore";
import {getUserToken} from "fulogics-ui-core";
import {createModel} from "@rematch/core";
import {iRootModel} from "../iRootModel";
import Store from "devextreme/data/abstract_store";
import ODataStore from "devextreme/data/odata/store";
import {DataSourceOptions} from "devextreme/data/data_source";
import Singleton from "fulogics-ui-core/dist/Singleton";
import insertToCollectionFunc, {insertToCollectionPayload} from 'fulogics-ui-core/dist/store/helpers/insertToCollectionFunc'

export const COSOrderReturnStepPayloadODataEndpoint = `${configuration.API_BASE_URL}/odata/ReturnStepPayloads/Store`;
export const COSOrderReturnStepPayloadStore = ODataFulogicsStore({
        url: COSOrderReturnStepPayloadODataEndpoint,
        key: 'id',
        keyType: 'String',
    },
    {
        createByCollectionId: (collectionId?: string) => ((collectionId ? {
            store: COSOrderReturnStepPayloadStore,
            reshapeOnPush: true,
            customQueryParams:
                {
                    collectionId: collectionId?.toString()
                }
        } : undefined) as DataSourceOptions)
    });


export type COSOrderReturnStepPayloadState = {}

export const COSOrderReturnStepPayloadModel = createModel<iRootModel>()({
    state: {} as COSOrderReturnStepPayloadState,

    effects: (dispatch) => ({
        async insertPayloadItemToCollection<T>(payload: insertPayloadItemPayload & insertToCollectionPayload<T>) {
            return insertToCollectionFunc({
                ...payload,
                //
                url: "/odata/ReturnStepPayloadsCollections/InsertPayloadItem",
                store: COSOrderReturnStepPayloadStore
            })
        },
        async deleteItem(payload: deleteItemPayload) {
            COSOrderReturnStepPayloadStore.remove(payload.itemId)
        },

    }),


    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore() // OrderStepReturnData
        {
            return COSOrderReturnStepPayloadStore;
        }
    }),
})

export default COSOrderReturnStepPayloadModel;

export type insertPayloadItemPayload =
    {
        collectionId: string
    }

export type deleteItemPayload =
    {
        itemId?: string
    }